module.exports = __webpack_public_path__ + "static/media/resetImage.e74b9b55.png";